<div class="d-flex mb-2 align-items-center">
  <typography look="H3">{{ caption }}</typography>
  <typography look="inputPlaceholder" *ngIf="totalCount > queryLimit" class="ms-auto me-3"
    >Displaying {{ itemsCount }} out of {{ totalCount }}</typography
  >
</div>

<ng-content></ng-content>
